const bundle = {
  get requiredBases() {
    return window.requiredBases || 0;
  },
  get requiredScents() {
    return window.requiredScents || 0;
  },
  bases: [],
  scents: [],
}

class CandleBundle extends HTMLElement {
  /** @type {'bases' | 'scents'} */
  activeTab = ['containers', 'both'].includes(window.bundleType) ? 'bases' : 'scents';

  constructor() {
    super();
  }

  populateOptions() {
    /** @type {HTMLDivElement[]} */
    const scentOptions = window.scents.map(scent => {
      return createOption(scent, 'scent');
    });

    /** @type {HTMLDivElement[]} */
    const baseOptions = window.bases.map(base => {
      return createOption(base, 'base');
    });

    function createOption(variant, type) {
      const option = createElementFromTemplate('bundle-option');

      option.setAttribute('data-type', type);
      option.setAttribute('data-id', variant.id);

      // K5.31: the per scent hook for the tile glow. The name comes from the variant the
      // section already hands us (window.scents, product.metafields.bundle.scents), the
      // same string the next lines write into .config__name, never from a list of scent
      // names typed in here and never from the tile's position, which differs by product.
      // assets/candle-bundle.css maps the class to --m. Scents only: base and container
      // tiles keep the neutral shadow.
      const scent = String(variant.title || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
      if (type === 'scent' && scent) option.classList.add('option__config--' + scent);

      const button = option.querySelector('.config__button');
      button.style.backgroundImage = `url(${variant.featured_image.src})`;

      const label = option.querySelector('.config__name');
      label.innerText = variant.title;

      return option;
    }

    const basesContainer = document.querySelector('.tab__content[data-tab="bases"] .bundle__options');
    const scentsContainer = document.querySelector('.tab__content[data-tab="scents"] .bundle__options');

    if (basesContainer) {
      basesContainer.innerHTML = '';
      basesContainer.append(...baseOptions);

      const baseCount = baseOptions.length;
      basesContainer.setAttribute('data-four-options', baseCount >= 4);
    }

    if (scentsContainer) {
      scentsContainer.innerHTML = '';
      scentsContainer.append(...scentOptions);

      const scentCount = scentOptions.length;
      scentsContainer.setAttribute('data-four-options', scentCount >= 4);
    }
  }

  updateOptions() {
    this.options.forEach(option => {
      /** @type {'base' | 'scent'} */
      const type = option.getAttribute('data-type');
      const id = option.getAttribute('data-id');

      /** @type {HTMLButtonElement} */
      const add = option.querySelector('.quantity-add');
      /** @type {HTMLButtonElement} */
      const remove = option.querySelector('.quantity-remove');
      const count = option.querySelector('.config__quantity span');

      option.setAttribute('data-count', count.innerText);

      const baseCount = bundle.bases.length;
      const scentCount = bundle.scents.length;

      if (type === 'base') {
        if (baseCount === 0) {
          remove.setAttribute('disabled', 'true');
        } else {
          remove.removeAttribute('disabled');
        }

        if (baseCount >= bundle.requiredBases) {
          add.setAttribute('disabled', 'true');
        } else {
          add.removeAttribute('disabled');
        }

        count.innerText = this.getBaseCount(id);
      } else {
        if (scentCount === 0) {
          remove.setAttribute('disabled', 'true');
        } else {
          remove.removeAttribute('disabled');
        }

        if (scentCount >= bundle.requiredScents) {
          add.setAttribute('disabled', 'true');
        } else {
          add.removeAttribute('disabled');
        }

        count.innerText = this.getScentCount(id);
      }
    });

    this.updateOverlay();
  }

  updateOverlay() {
    this.overlay.update();
  }

  initOptions() {
    this.options.forEach(option => {
      /** @type {'base' | 'scent'} */
      const type = option.getAttribute('data-type');
      const id = option.getAttribute('data-id');

      /** @type {HTMLButtonElement} */
      const add = option.querySelector('.quantity-add');
      /** @type {HTMLButtonElement} */
      const remove = option.querySelector('.quantity-remove');
      const count = option.querySelector('.config__quantity span');

      option.addEventListener('click', (e) => {
        if (e.target.closest('.config__quantity')) return;

        this.options.forEach(option => {
          option.classList.remove('config--focus');

          const optionQty = parseInt(option.querySelector('.config__quantity span').innerText);

          if (optionQty === 0) option.classList.remove('config--active')
        });

        option.classList.add('config--active');
        option.classList.add('config--focus');

        const variantDescription = [...window.baseDescriptions, ...window.scentDescriptions]
          .find(d => `${d.id}` === id)
          .description;

        const variantTitle = [...window.bases, ...window.scents].find(v => `${v.id}` === id)?.title;

        this.tabs.forEach(tab => tab.querySelector('.selected-variant-description').innerText = '');
        const tab = this.tabs.find(tab => tab.classList.contains('tab--active'));

        tab.querySelector('.selected-variant-description').innerHTML = `
          <h4>${variantTitle}</h4>
          <p>${variantDescription}</p>
        `;
      });

      add.addEventListener('click', () => {
        console.log('Add clicked:', type, id);
        if (type === 'base') {
          bundle.bases.push(id);
          count.textContent = this.getBaseCount(id);
        } else {
          bundle.scents.push(id);
          count.textContent = this.getScentCount(id);
        }
        console.log('Bundle state:', { bases: bundle.bases.length, scents: bundle.scents.length, requiredBases: bundle.requiredBases, requiredScents: bundle.requiredScents });

        this.updateOptions();
      });

      remove.addEventListener('click', () => {
        if (type === 'base') {
          const index = bundle.bases.indexOf(id);
          if (index !== -1) {
            bundle.bases.splice(index, 1);
          }

          count.textContent = this.getBaseCount(id);
        } else {
          const index = bundle.scents.indexOf(id);
          if (index !== -1) {
            bundle.scents.splice(index, 1);
          }

          count.textContent = this.getScentCount(id);
        }

        this.updateOptions();
      });
    });
  }

  getScentCount(id) {
    return bundle.scents.reduce((acc, _id) => {
      if (_id === id) return acc + 1;

      return acc;
    }, 0);
  }

  getBaseCount(id) {
    return bundle.bases.reduce((acc, _id) => {
      if (_id === id) return acc + 1;

      return acc;
    }, 0);
  }

  initTabButtons() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.setActiveTab(button.getAttribute('data-tab'));
      });
    });
  }

  /**
   * @param tab {'bases' | 'scents'}
   */
  setActiveTab(tab) {
    this.activeTab = tab;

    this.tabButtons.forEach(button => {
      if (button.getAttribute('data-tab') === tab) {
        button.classList.add('tab--active');
      } else {
        button.classList.remove('tab--active');
      }
    });

    this.tabs.forEach(content => {
      if (content.getAttribute('data-tab') === tab) {
        content.classList.add('tab--active');
      } else {
        content.classList.remove('tab--active');
      }
    });
  }

  connectedCallback() {
    const onReady = () => {
      /** @type {HTMLButtonElement[]} */
      this.tabButtons = Array.from(this.querySelectorAll('.candle-bundle__tab'));
      this.tabs = Array.from(this.querySelectorAll('.tab__content'));

      /** @type {BundleOverlay} */
      this.overlay = this.querySelector('candle-bundle-overlay');

      // Auto-add containers for scents_with_container type
      if (window.bundleType === 'scents_with_container' && window.bases && window.bases.length === 1 && window.actualRequiredBases > 0) {
        for (let i = 0; i < window.actualRequiredBases; i++) {
          bundle.bases.push(window.bases[0].id);
        }
      }

      this.populateOptions();

      /** @type {HTMLDivElement[]} */
      this.options = Array.from(this.querySelectorAll('.option__config'))

      this.initTabButtons();
      this.initOptions();
      this.setActiveTab(this.activeTab);

      // K5.141: the overlay element may not be upgraded yet when this runs (the three custom elements are
      // defined in order, the overlay last), so the prefill and the first selection wait for it. Without
      // this the Sampler prefill threw "this.overlay.update is not a function" on a fast load.
      customElements.whenDefined('candle-bundle-overlay').then(() => {
        // K5.135 (Ben, 24 Sep, a decision that had regressed): the Sampler opens with one of each
        // scent chosen, still editable. The section sets data-prefill only when the set needs
        // exactly as many scents as the product carries.
        if (this.dataset.prefill === 'one-each' && bundle.scents.length === 0
            && Array.isArray(window.scents) && window.scents.length === bundle.requiredScents) {
          window.scents.forEach(v => bundle.scents.push(`${v.id}`));
          this.options.forEach(o => { if (o.getAttribute('data-type') === 'scent') o.classList.add('config--active'); });
          this.updateOptions();
        }

        // K5.141 (Ben, 25 Sep): the first scent starts selected at 0 added, so its description shows and the
        // steppers explain how the picker works. The same click a customer makes.
        const firstScent = this.options.find(o => o.getAttribute('data-type') === 'scent');
        if (firstScent) firstScent.click();
      });
    }

    if (['complete', 'interactive'].includes(document.readyState)) {
      onReady()
    } else {
      document.addEventListener('DOMContentLoaded', onReady)
    }
  }

  disconnectedCallback() {
    console.log("Custom element removed from page.");
  }

  adoptedCallback() {
    console.log("Custom element moved to new page.");
  }

  attributeChangedCallback(name, oldValue, newValue) {
    console.log(`Attribute ${name} has changed.`);
  }
}

class Slider extends HTMLElement {
  slideIndex = 0;
  isDragging = false;
  startPosition = 0;
  currentTranslate = 0;
  prevTranslate = 0;

  constructor() {
    super();
  }

  connectedCallback() {
    if (this.classList.contains('slider--disabled')) return;

    const onReady = () => {
      /** @type {HTMLDivElement[]} */
      this.slideContainers = Array.from(this.querySelectorAll('.slide-container'))

      /** @type {HTMLDivElement[]} */
      this.slideCount = this.querySelector('.slide-container__viewport')
      .querySelectorAll('.slide-container__viewport .images-slider__slide')
        .length;

      /** @type {HTMLButtonElement} */
      this.prevSlideButton = this.querySelector('.button-prev');

      /** @type {HTMLButtonElement} */
      this.nextSlideButton = this.querySelector('.button-next');

      /** @type {HTMLDivElement} */
      this.trackNotch = this.querySelector('.slide-indicator__notch');

      // Initialize slider position values
      this.slideIndex = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.isDragging = false;

      this.initSlideButtons();
      this.updateTrackNotch();
      this.initSlideGesture();
    }

    if (['complete', 'interactive'].includes(document.readyState)) {
      onReady()
    } else {
      document.addEventListener('DOMContentLoaded', onReady)
    }
  }

  updateTrackNotch() {
    this.trackNotch.style.width = `${100 / this.slideCount}%`;
    this.trackNotch.style.transform = `translateX(${this.slideIndex * 100}%)`;
  }

  initSlideButtons() {
    this.prevSlideButton.addEventListener('click', () => {
      this.slideIndex--;

      if (this.slideIndex < 0) {
        this.slideIndex = this.slideCount - 1;
      }

      this.updateSlide();
    });

    this.nextSlideButton.addEventListener('click', () => {
      this.slideIndex++;

      if (this.slideIndex >= this.slideCount) {
        this.slideIndex = 0;
      }

      this.updateSlide();
    });
  }

  updateSlide() {
    this.slideContainers.forEach(container => container.style.transform = `translateX(${this.slideIndex * -100}%)`);
    this.updateTrackNotch();
  }

  setPositionByIndex() {
    this.currentTranslate = this.slideIndex * -100;
    this.updateSlidePosition();
    this.updateTrackNotch();
  }

  updateSlidePosition() {
    this.slideContainers.forEach(container => container.style.transform = `translateX(${this.currentTranslate}%)`);
  }

  initSlideGesture() {
    // Touch events
    this.addEventListener('touchstart', this.startGesture.bind(this));
    this.addEventListener('touchmove', this.moveGesture.bind(this));
    this.addEventListener('touchend', this.endGesture.bind(this));

    // Mouse events
    this.addEventListener('mousedown', this.startGesture.bind(this));
    this.addEventListener('mousemove', this.moveGesture.bind(this));
    document.addEventListener('mouseup', this.endGesture.bind(this)); // Global to ensure it captures the end
  }

  startGesture(event) {
    this.isDragging = true;
    this.startPosition = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;

    this.slideContainers.forEach(container => container.style.transition = 'none');

     // Disable transition for smoother dragging
  }

  moveGesture(event) {
    if (this.isDragging) {
      const currentPosition = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
      const distanceMoved = currentPosition - this.startPosition;

      // Calculate the drag distance as a fraction of the slider's width
      // Assuming this.offsetWidth gives the width of the slider component
      const percentageMoved = (distanceMoved / this.offsetWidth) * 100;

      // Apply a scaling factor to reduce movement speed. Adjust the scaling factor as needed.
      const scalingFactor = 1; // Change this to a smaller value if movement is too fast, e.g., 0.5
      this.currentTranslate = this.prevTranslate + (percentageMoved * scalingFactor);

      this.updateSlidePosition();
    }
  }

  endGesture() {
    if (this.isDragging) {
      this.isDragging = false;
      const movedBy = this.currentTranslate - this.prevTranslate;

      // Snap logic here, for example:
      if (movedBy < -50 / this.slideCount) { // Move forward if moved more than a threshold
        this.slideIndex++;
      } else if (movedBy > 50 / this.slideCount) { // Move backward if moved more than a threshold
        this.slideIndex--;
      }

      // Bounds checking
      if (this.slideIndex >= this.slideCount) {
        this.slideIndex = 0;
      } else if (this.slideIndex < 0) {
        this.slideIndex = this.slideCount - 1;
      }

      // Update to the new index
      this.setPositionByIndex();

      this.prevTranslate = this.currentTranslate;

      // Re-enable transition
      this.slideContainers.forEach(container => container.style.transition = 'transform 0.3s ease-out');
    }
  }
}

class BundleOverlay extends HTMLElement {
  _expanded = false;

  constructor() {
    super();
  }

  connectedCallback() {
    /** @type {HTMLButtonElement} */
    this.expandButton = this.querySelector('.overlay__expand');

    /** @type {HTMLButtonElement} */
    this.addToCartButton = this.querySelector('.overlay__add-to-cart');

    /** @type {CandleBundle} */
    this.bundleConfigurator = this.closest('candle-bundle')
    
    this.addSlots();
    this.setupEventListeners();
    this.update();
    this.updateAtc();
    this.watchFooter();
  }

  // K5.108. At phone widths this overlay is a fixed bar floating over the page. It stands down
  // while the footer group's top is inside the viewport, so the footer's screen carries the footer
  // alone and its legal line reads clear, and comes back when the footer leaves. At 1024px and up
  // the overlay is the page's static buy-box column (candle-bundle.css), so only a FIXED overlay
  // stands down, and never an expanded one: the customer is using it. Hidden, not moved.
  watchFooter() {
    this._standDown = () => {
      const down = !!this._footerInView && !this._expanded && getComputedStyle(this).position === 'fixed';
      this.style.visibility = down ? 'hidden' : '';
    };
    const start = () => {
      const footer = document.querySelector('.shopify-section-group-footer-group');
      if (!footer || !('IntersectionObserver' in window)) return;
      new IntersectionObserver((entries) => {
        this._footerInView = entries[0].isIntersecting;
        this._standDown();
      }).observe(footer);
      window.addEventListener('resize', this._standDown, { passive: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }

  addSlots() {
    this.baseSlots = Array.from(this.querySelectorAll('.slot.slot--base'));
    this.scentSlots = Array.from(this.querySelectorAll('.slot.slot--scent'));
  }

  update() {
    this.baseSlots.forEach((slot, index) => {
      applySlotVariant(slot, index, 'base');
    });

    this.scentSlots.forEach((slot, index) => {
      applySlotVariant(slot, index, 'scent');
    });

    this.updateInstructions();
    this.updateAtc();
    this.updateSlots();

    function applySlotVariant(slot, index, type) {
      const variants = type === 'scent' ? window.scents : window.bases;
      const bundleIds = type === 'scent' ? bundle.scents : bundle.bases;

      const variant = variants.find(b => `${b.id}` === `${bundleIds[index]}`);
      if (!variant) {
        slot.style.backgroundImage = 'unset';
        slot.classList.remove('slot--occupied');
        return;
      }

      slot.style.backgroundImage = `url(${variant.featured_image.src})`;
      slot.classList.add('slot--occupied');
    }
  }

  updateSlots() {
    const bases = this.querySelector('.slots--bases');
    const scents = this.querySelector('.slots--scents');
    const basesHeading = this.querySelector('.overlay-slot-heading.heading--bases');
    const scentsHeading = this.querySelector('.overlay-slot-heading.heading--scents');

    if (bases) {
      if (bundle.bases.length === 0) {
        bases.setAttribute('data-empty', 'true');
        basesHeading.setAttribute('data-empty', 'true');
      } else {
        bases.removeAttribute('data-empty');
        basesHeading.removeAttribute('data-empty');
      }
    }

    if (scents) {
      if (bundle.scents.length === 0) {
        scents.setAttribute('data-empty', 'true');
        scentsHeading.setAttribute('data-empty', 'true');
      } else {
        scents.removeAttribute('data-empty');
        scentsHeading.removeAttribute('data-empty');
      }
    }
  }

  updateInstructions() {
    const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;
    const text = (() => {
      if (bundle.bases.length < bundle.requiredBases) {
        return bundle.bases.length === 0
          ? `Choose ${plural(bundle.requiredBases, 'container')}`
          : `${bundle.bases.length} of ${plural(bundle.requiredBases, 'container')} chosen`;
      }

      if (bundle.scents.length < bundle.requiredScents) {
        return bundle.scents.length === 0
          ? `Choose ${plural(bundle.requiredScents, 'scent')}`
          : `${bundle.scents.length} of ${plural(bundle.requiredScents, 'scent')} chosen`;
      }

      return document.querySelector('candle-bundle[data-prefill="one-each"]') ? 'One of each scent' : 'Your set is ready';
    })();

    this.querySelector('.header__text p').innerText = text;
  }

  updateAtc() {
    const isComplete = bundle.bases.length >= bundle.requiredBases && bundle.scents.length >= bundle.requiredScents;
    
    if (isComplete) {
      this.addToCartButton.classList.remove('add-to-cart--disabled');
      this.addToCartButton.removeAttribute('disabled');
    } else {
      this.addToCartButton.classList.add('add-to-cart--disabled');
      this.addToCartButton.setAttribute('disabled', 'true');
    }
  }

  async addToCart() {
    this.addToCartButton.setAttribute('disabled', true);

    const payload = {
      'items': [{
        'id': window.variant.id,
        'quantity': 1,
        properties: {
          Scents: bundle.scents.map(id => window.scents.find(v => v.id == id).title).join(', '),
          Bases: bundle.bases.map(id => window.bases.find(v => v.id == id).title).join(', '),
        }
      }]
    };
    
    let ok = false;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      ok = response.ok;
    } catch (e) {
      ok = false;
    }

    this.addToCartButton.removeAttribute('disabled');

    if (!ok) {
      const label = this.addToCartButton.querySelector('.add-to-cart__text');
      if (label) {
        const prev = label.textContent;
        label.textContent = 'Something went wrong, try again';
        setTimeout(() => { label.textContent = prev; }, 4000);
      }
      return;
    }

    window.location.href = '/cart';
  }

  setupEventListeners() {
    if (!this.expandButton) {
      console.error('expandButton is null!', this);
      return;
    }
    
    this.expandButton.addEventListener('click', () => this.expanded = !this.expanded);

    // K5.135: on a phone the whole bar opens the panel, not only the plus.
    const header = this.querySelector('.overlay__header');
    if (header) header.addEventListener('click', (e) => {
      if (e.target.closest('.overlay__expand')) return;
      if (getComputedStyle(this).position !== 'fixed') return;
      this.expanded = !this.expanded;
    });

    this.baseSlots.forEach((slot, index) => {
      const remove = slot.querySelector('.slot__remove');

      if (!remove) return;

      remove.addEventListener('click', () => {
        if (index < bundle.bases.length) {
          bundle.bases.splice(index, 1);
        }
        this.bundleConfigurator.updateOptions();
      });
    });

    this.scentSlots.forEach((slot, index) => {
      const remove = slot.querySelector('.slot__remove');

      if (!remove) return;

      remove.addEventListener('click', () => {
        if (index < bundle.scents.length) {
          bundle.scents.splice(index, 1);
        }
        this.bundleConfigurator.updateOptions();
      });
    });

    this.addToCartButton.addEventListener('click', () => {
      this.addToCart();
    })
  }

  get expanded() {
    return this._expanded;
  }

  set expanded(expanded) {
    this._expanded = expanded;

    if (expanded) {
      this.classList.add('overlay--active');
    } else {
      this.classList.remove('overlay--active');
    }
    if (this._standDown) this._standDown();
  }
}


customElements.define("candle-bundle-slider", Slider);
customElements.define("candle-bundle", CandleBundle);
customElements.define("candle-bundle-overlay", BundleOverlay);

function createElementFromTemplate(templateId) {
  /** @type {HTMLTemplateElement} */
  const template = document.querySelector(`template#${templateId}`);

  return template.content.cloneNode(true).firstElementChild;
}




